<div class="inner">
    <div class="stickyContent"
         [elementHeight]="uid">
        <ng-content></ng-content>
    </div>
</div>